import { useState } from 'react'

import { F0Box, TwoColumnLayout } from '@factorialco/f0-react'
import { IncentivesCompensationPlanDetailDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { CompensationPlanAssignments } from './CompensationPlanAssignments'
import { CompensationPlanMetrics } from './CompensationPlanMetrics'
import { SideContent } from './SideContent'
import { type DetailTab, Tabs } from './Tabs'
import { COMPENSATION_PLAN_ACTION } from 'modules/incentives/routes/resource_headers/CompensationPlanDetailHeader'
import { getCurrentPeriod } from 'modules/incentives/lib/period'

export default function CompensationPlanDetail() {
  const { id } = useStrictParams<'id'>()
  const { company } = useCurrentSession()

  const { data, loading, error } = useQuery(IncentivesCompensationPlanDetailDocument, {
    variables: { companyId: company.id, planId: String(id) },
  })

  const plan = data?.incentives?.compensationPlan
  const periods = plan?.compensationPlanPeriods ?? []

  const [selectedPeriodId, setSelectedPeriodId] = useState<string | null>(null)
  const [activeTab, setActiveTab] = useState<DetailTab>('metrics')
  const currentPeriod = getCurrentPeriod(periods)?.id
  const periodId = selectedPeriodId ?? currentPeriod

  const sendToCompensation = () => {
    // TODO: implement
  }

  const handleActionClick = (key: string) => {
    switch (key) {
      case COMPENSATION_PLAN_ACTION.SendToCompensation:
        sendToCompensation()
        break
    }
  }

  return (
    <ResponsivePage.Body
      loading={loading}
      error={error}
      variant="fullscreen"
      onActionClick={handleActionClick}
    >
      {plan && periodId && (
        <TwoColumnLayout
          mainColumnPosition="right"
          sideContent={
            <SideContent
              periods={periods}
              recurrence={plan.recurrence}
              currentPeriodId={currentPeriod}
              selectedPeriodId={periodId}
              onPeriodSelect={setSelectedPeriodId}
            />
          }
        >
          <F0Box>
            <Tabs activeTab={activeTab} onTabChange={setActiveTab} />
            <F0Box marginTop="md">
              {activeTab === 'metrics' ? (
                <CompensationPlanMetrics periodId={periodId} />
              ) : (
                <CompensationPlanAssignments planId={String(id)} periodId={periodId} />
              )}
            </F0Box>
          </F0Box>
        </TwoColumnLayout>
      )}
    </ResponsivePage.Body>
  )
}
